// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorRelationshipModelsPrescriptionRelationshipModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorRelationshipModelsPrescriptionRelationshipModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorRelationshipModelsPrescriptionRelationshipModel.discriminator = undefined;
EnterpriseCoordinatorRelationshipModelsPrescriptionRelationshipModel.additionalProperties = false;
EnterpriseCoordinatorRelationshipModelsPrescriptionRelationshipModel.attributeTypeMap = [
    {
        "name": "signatures",
        "baseName": "signatures",
        "type": ""
    },
    {
        "name": "documentId",
        "baseName": "documentId",
        "type": "number"
    },
    {
        "name": "prescriberId",
        "baseName": "prescriberId",
        "type": "number"
    },
    {
        "name": "ndcId",
        "baseName": "ndcId",
        "type": "number"
    },
    {
        "name": "writtenOn",
        "baseName": "writtenOn",
        "type": "Date"
    },
    {
        "name": "daySupply",
        "baseName": "daySupply",
        "type": "number"
    },
    {
        "name": "refills",
        "baseName": "refills",
        "type": "number"
    },
    {
        "name": "quantity",
        "baseName": "quantity",
        "type": "number"
    },
    {
        "name": "directions",
        "baseName": "directions",
        "type": "string"
    },
    {
        "name": "dispenseTypeId",
        "baseName": "dispenseTypeId",
        "type": "number"
    },
];
//# sourceMappingURL=enterpriseCoordinatorRelationshipModelsPrescriptionRelationshipModel.js.map